export const TEST_ID_NOT_ENOUGH_REVIEW_TEXT = 'TEST_ID_NOT_ENOUGH_REVIEW_TEXT';
